var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-warp"},[_c('baidu-map',{staticClass:"map",attrs:{"ak":_vm.bdAk,"zoom":_vm.zoom,"dragging":true,"scroll-wheel-zoom":true},on:{"ready":_vm.handler,"zoomend":_vm.syncCenterAndZoom}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }